import React, { Component, Fragment } from 'react'
import { SubHeader, LineBreak, ShadowContainer, Description, HeaderTitle } from '../../healtheraComponents'
import { formatDate } from '../../helpers'
import { Flex, Box } from 'reflexbox'
import { calculateTotal } from '../../helpers'

const currency = 'GBP';

export default class DealSummary extends Component {

  render() {
    const {
      header,
      deal: {
        chain_name, vat, address, primaryUser, discount,
        commissions: {
          transaction_fee: transaction,
          transaction_fee_percentage: transactionPercent,
          delivery, collect, otc_commission,
        } = {},
        currentContract: { startDate, slots, count, trialPeriod, unitPrice } = {}
      } = {}
    } = this.props;

    return (
      <Fragment>
        <Flex>
          <Box w={`50%`} >
            {chain_name && <SubHeader color='#2f9d6d' title={chain_name} />}
            <SubHeader title='Business Address' />
            {address && <Address data={address} />}
            <SubHeader title='Account Administrator' />
            {primaryUser && <AccountAdmin data={primaryUser} />}
          </Box>
          <Box w={`50%`}>
            <ShadowContainer>
              <HeaderTitle borderBottom={`1px solid #c2c2c2`} fontSize={`36px`} color={`#2f9d6d`} padding={`10px 0 20px 0`}>{header}</HeaderTitle>
              <Description>
                {unitPrice && <p>Price (Per Month Per Site)<b>{currency} {unitPrice}/Month</b></p>}
                {slots && <p>Number of Pharmacy Sites<b>{slots}</b></p>}
                {transaction && <p>Transaction fee<b>{currency} {transaction}</b></p>}
                {transactionPercent && <p>Transaction fee %<b>{transactionPercent}%</b></p>}
                {delivery && <p>Commission fee - Delivery<b>{currency} {delivery}</b></p>}
                {collect && <p>Commission fee - Collection<b>{currency} {collect}</b></p>}
                {otc_commission && <p>Commission rate - E-Commerce %<b>{otc_commission}%</b></p>}
                {startDate && <p>Contract Start Date<b>{formatDate(startDate)}</b></p>}
                {count && <p>Initial Subscription Term<b>{count} Months</b></p>}
                {trialPeriod && <p>Trial Period<b>{trialPeriod ? `${trialPeriod} Months` : '-'}</b></p>}
                <p>Notice Period<b> 14 Days</b></p>
                {discount > 0 && <p>Discount<b>{discount ? `${discount} %` : '-'}</b></p>}
              </Description>
              <LineBreak />
              <Description padding={`20px 0 0 0`}>
                {unitPrice && slots && <p><b>Subscription Fee per Month:</b><b>{currency} {calculateTotal(unitPrice, slots, discount, vat)} </b></p>}
              </Description>
              {vat && <HeaderTitle fontSize={`13px`} color={`#2f9d6d`} fontWeight={`normal`} textalign={`right`}>VAT Excluded</HeaderTitle>}
            </ShadowContainer>
          </Box>
        </Flex>
      </Fragment>
    )
  }
}

const Address = ({ data: { postcode, name, street, city, country } }) => {
  return (<Fragment>
    <p>{name}</p>
    <p>{street}</p>
    <p>{city}</p>
    <p>{postcode}</p>
    <p>{country}</p>
  </Fragment>)
}

const AccountAdmin = ({ data: { firstName, lastName, position, email, contact } }) => {
  return (<Fragment>
    <p>{firstName} {lastName}</p>
    <p>{position}</p>
    <p>{email}</p>
    <p>{contact}</p>
  </Fragment>)
}
